<template>
    <label class="control-label-2">
        <input
                class="form-control-2"
                type="checkbox"
                v-model="value"
                :disabled="disabled"
                :maxlength="schema.max"
                :placeholder="schema.placeholder"
                :readonly="schema.readonly">
        {{schema.text}}
    </label>

</template>

<script>


    import {abstractField} from "vue-form-generator/dist/vfg-core.js";

    export default {
        mixins: [abstractField]
    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/fields/fieldCustomCheckbox.vue